export enum PackageEndpoints {
  FetchPackage = '/packages/:id',
  ById = '/packages/:id',
  Create = '/packages',
  FetchPackageCount = '/packages/active/count',
  FetchAllSponsorships = '/packages/all',
  FetchAllServices = '/packages/services-listing/all-services'
}
